"use client";

// Form primitives for the free Pine Script generator. Relocated here from the
// (removed) AI Lab so the public /tools/pine-demo surface is self-contained.

const labelClass =
  "block text-[11px] uppercase tracking-[0.14em] text-[var(--fg-subtle)] mb-1.5";
const compactInputClass =
  "w-full rounded-[var(--radius)] border border-[var(--border)] bg-[var(--bg)] px-3 py-2 text-sm outline-none focus:border-[var(--brand)]/60 focus:ring-2 focus:ring-[var(--brand)]/15";

export const labelStyles = labelClass;
export const compactInputStyles = compactInputClass;

export function NumberField({
  id,
  label,
  value,
  min,
  max,
  step = 1,
  onChange,
  disabled = false,
}: {
  id: string;
  label: string;
  value: number;
  min: number;
  max: number;
  step?: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}) {
  return (
    <div className={disabled ? "opacity-50" : undefined}>
      <label className={labelClass} htmlFor={id}>
        {label}
      </label>
      <input
        id={id}
        type="number"
        className={`${compactInputClass} disabled:cursor-not-allowed`}
        min={min}
        max={max}
        step={step}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(Number(e.target.value))}
      />
    </div>
  );
}

export function Toggle({
  label,
  checked,
  onChange,
  disabled = false,
}: {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}) {
  return (
    <label
      className={`inline-flex h-10 items-center justify-center gap-2 rounded-[var(--radius)] border border-[var(--border)] bg-[var(--bg)] px-3 text-xs text-[var(--fg-muted)] ${
        disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
      }`}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        className="size-3 accent-[var(--brand)]"
      />
      <span>{label}</span>
    </label>
  );
}
